import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { API_URL, use_store } from '../store';
import Button from './button';
import { PaymentLoader } from './Loading';

export const CheckoutForm = () => {
  const { user, token, unique_data, sub_type } = use_store();
  const [show_loader, set_show_loader] = useState(true);
  
  useEffect(() => {
    // Hide loader after 3 seconds
    const timeout = setTimeout(() => {
      set_show_loader(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);
  
  useEffect(() => {
    let checkout: any = null;
    
    (async () => {
      // Get the product_id based on sub_type (weekly or monthly)
      const product_id = sub_type === 'weekly' ? unique_data?.stripe_product_id : unique_data?.stripe_product_id_2;
      
      if (!product_id) {
        console.error('No product ID available in unique_data');
        return;
      }
      
      const stripe = await loadStripe('pk_live_51McxWiJJTSpaS1qxikVZ0PKkEbm5B6ZX9ArgWjdELVEhAPdWMvI9QNeROCMnNtoGofONrTvSdXnqvgTEPCwWQ4nC0024fVcDwu');
      const { clientSecret } = await fetch(API_URL + '/api/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          productId: product_id,
          customerEmail: user?.email,
          token: token,
        })
      }).then(r => r.json());

      checkout = await stripe!.initEmbeddedCheckout({ clientSecret });
      checkout.mount('#checkout');
    })();
    
    // Cleanup function to destroy the checkout when component unmounts
    return () => {
      if (checkout) {
        checkout.destroy();
      }
    };
  }, [user?.email, unique_data, sub_type]);

  return (
    <>
      <div id="checkout" />
      {show_loader && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
          <PaymentLoader />
        </div>
      )}
    </>
  );
}

// Main component that decides what to show
const StripePortal = () => {
  const { 
    user, 
    unique_data, 
    sub_type, 
    t,
    refresh_current_user,
    refresh_unique_data,
    call_confirm_user_created
  } = use_store();
  
  useEffect(() => {
    // Fire the same initialization events as pay.tsx (no need to wait)
    const initializeData = async () => {
      refresh_current_user();
      refresh_unique_data();
      call_confirm_user_created();
    };
    
    initializeData();
  }, []);
  
  // If user is subscribed, redirect to home
  if (user?.subscribed) {
    window.location.href = '/';
    return null;
  } else {
    // Get the payment link based on sub_type (weekly or monthly)
    const payment_link = sub_type === 'weekly' ? unique_data?.stripe_url : unique_data?.stripe_url_2;
    // Add email prefill to the payment link
    const payment_link_with_email = payment_link && user?.email 
      ? `${payment_link}?locked_prefilled_email=${encodeURIComponent(user.email)}`
      : payment_link;
    
    return (
      <div className='fixed inset-0 w-screen h-screen overflow-y-auto bg-white z-50'>
        <div className='w-full min-h-full flex flex-col items-center p-[16px]'>
          <div className='w-full max-w-[640px]'>
            <CheckoutForm />
            <div className='w-full flex flex-col justify-center items-center'>
              <div className=''>
                <p className='text-primary stitle mt-[332px] mb-[12px]'>{t("You can pay directly on Stripe's website")}</p>
                <Button href={payment_link_with_email || 'https://buy.stripe.com/4gMeVe1jX5WtbjJbwA4ko00'}>{t("Secure payment via stripe")}</Button>
                <div className='mb-[64px]'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default StripePortal;

